/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import { contactsEntity } from './contact.schema';

export const notificationsEntity = new schema.Entity('notifications', {
  receivers: [contactsEntity],
  sender: contactsEntity
});
